import React from "react";
import styled from "@emotion/styled";
import GraphLegend from "components/GraphLegend";
import CommonUtils from "services/common/utils";
import ParkkiTheme from "themes/ParkkiTheme";

const Container = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  padding-right: ${ParkkiTheme.spacings.base};
  padding-left: ${ParkkiTheme.spacings.base};
  align-items: center;
`;

const GraphContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  height: 26px;
`;

const LeftCircleContainer = styled.div`
  height: 26px;
  width: 26px;
  border-radius: 50%;
  margin-right: -13px;
  z-index: 4;
  background-color: ${(props: { backgroundColor: string }) =>
    props.backgroundColor};
`;

const RightCircleContainer = styled.div`
  height: 26px;
  width: 26px;
  border-radius: 50%;
  background-color: ${(props: { backgroundColor: string }) =>
    props.backgroundColor};
`;

const LeftContainer = styled.div`
  height: 100%;
  min-width: 75px;
  z-index: 4;
  margin-right: -13px;
  width: ${(props: { width?: number }): string => `${props.width}%`};
  background-color: ${(props: { color?: string }) => props.color};
`;

const PercentageContainer = styled.div`
  height: 26px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: ${ParkkiTheme.colors.white};
`;

const ValueLabel = styled.span`
  margin-right: ${ParkkiTheme.spacings.teeny};
  font-size: ${ParkkiTheme.fontSizes.small};
`;

type Props = {
  data: {
    label: string;
    color: string;
    percentage: number;
    value: number;
    overridePercentage?: string;
  }[];
};

function LineMultiPercentage({ data }: Props): JSX.Element {
  return (
    <Container>
      <GraphContainer>
        {data?.map((item, index: number) => (
          <React.Fragment key={`${item.percentage}-${index}`}>
            <LeftCircleContainer backgroundColor={item.color} />
            <LeftContainer color={item.color} width={item.percentage}>
              <PercentageContainer>
                <ValueLabel>{CommonUtils.formatNumber(item?.value)}</ValueLabel>
                {item.overridePercentage ? (
                  <span>{`(${item.overridePercentage})`}</span>
                ) : (
                  <span>{`${Math.floor(item?.percentage)}%`}</span>
                )}
              </PercentageContainer>
            </LeftContainer>
            {index === data?.length - 1 && (
              <RightCircleContainer backgroundColor={item.color} />
            )}
          </React.Fragment>
        ))}
      </GraphContainer>
      <GraphLegend data={data} />
    </Container>
  );
}

export default LineMultiPercentage;
